module.exports = __webpack_public_path__ + "img/shrimp_th_new_0006.82f48660.png";